import styled from '@emotion/styled';

const CategoryHeading = styled.h2`
  && {
    margin: 0;
    text-transform: uppercase;
    font-size: var(--size-body1);
    color: var(--black-high);
    font-family: var(--font-secondary);
    display: block;

    ${(properties) => properties.jobOfTheWeek && `
      && {
        color: var(--white);
        background-color: var(--primary-color);
        display: block;
        text-align: center;
        padding: 4px 12px;
      }
    `}
  }
`;

export default CategoryHeading;
